module.exports = __webpack_public_path__ + "static/media/Rosemary.c64330fe.png";